// Converters lifted from Crop.jsx:32–44 so both tools agree
export const UNITS = ['pt', 'in', 'mm'];
export const UNIT_STEP = { pt: 1, in: 0.05, mm: 1 };

export function ptToUnit(pt, unit) {
  if (unit === 'in') return +(pt / 72).toFixed(3);
  if (unit === 'mm') return +(pt / 72 * 25.4).toFixed(2);
  return +pt.toFixed(1);
}

export function unitToPt(val, unit) {
  const n = parseFloat(val);
  if (isNaN(n)) return 0;
  if (unit === 'in') return n * 72;
  if (unit === 'mm') return n / 25.4 * 72;
  return n;
}

export function clampPt(pt, min, max) {
  return Math.min(max, Math.max(min, pt));
}
